import axios from 'axios';
import qs from 'qs';
import { _csrfToken_ } from '../Constants';
import Urls from './Urls';

const AuthService = {

	login: async (credentials) => {
		try {
			const response = await axios.post(
				Urls.LOGIN,
				qs.stringify(credentials),
				{
					headers: { "Content-Type": "application/x-www-form-urlencoded" }
				}
			);
			return response.data;
		} catch (e) {
			console.error(e);
			return e.response.data;
		}
	},


	isCsrfValid: async (csrfToken) => {
		try {
			const response = await axios.post(
				Urls.CSRF_VALID,
				qs.stringify({}),
				{
					headers: { "Content-Type": "application/x-www-form-urlencoded" },
					[_csrfToken_]: csrfToken
				}
			);
			return response.data.valid;
		} catch (e) {
			console.error(e);
			return false;
		}
	}
}

export default AuthService;